import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PlannerPage from './pages/PlannerPage';
import AvisosPage from './pages/AvisosPage';
import SacPage from './pages/SacPage';
import "./styles/App.css";

function App() {
  return (
    <Router>
      <Routes>
        {/* Rota padrão redireciona para o planejador */}
        <Route path="/" element={<Navigate to="/planner" replace />} />
        
        {/* Página do planejador de rotas */}
        <Route path="/planner" element={<PlannerPage />} />
        
        {/* Página de avisos */}
        <Route path="/avisos" element={<AvisosPage />} />
        
        {/* Página de SAC/Contato */}
        <Route path="/sac" element={<SacPage />} />
        
        {/* Rota 404 - redireciona para planner */}
        <Route path="*" element={<Navigate to="/planner" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
